<template>
  <div class="flashbuy" :style="{ background: pageConfig.bgcolor }">
    <div class="banner">
      <img v-lazy="pageConfig.img" />
    </div>
  </div>
</template>
<script>
import api from '../../utils/api'
export default {
  data () {
    return {
      pageConfig: {}
    }
  },
  created () {
    this.getPageJson()
  },
  methods: {
    async getPageJson () {
      const data = await api.getJsonVersion('notification')
      this.pageConfig = data['notification-1'].data[0]
      document.title = this.pageConfig.title
    }
  }
}
</script>
<style lang='less' scoped>
.flashbuy {
  min-height: 100vh;
  .banner {
    position: relative;
    p {
      position: absolute;
      bottom: 0.62rem;
      left: -0.3rem;
      transform: translate(50%, 0);
      text-align: center;
      font-size: @fz22;
      color: #dc1e36;
      padding: 0 0.15rem;
      line-height: 0.55rem;
      height: 0.55rem;
      background: linear-gradient(180deg, #fdfcdc, #f9f7b6);
      border-radius: 0.28rem;
    }
  }
  .cards {
    margin: 0.24rem;
    li {
      border-radius: 0.08rem;
      background: #fff;
      padding: 0.2rem;
      display: flex;
      margin-bottom: 0.2rem;
      aside {
        width: 1.9rem;
        height: 1.9rem;
      }
      article {
        width: 4.4rem;
        margin-left: 0.2rem;
        height: 1.9rem;
        position: relative;
        h3 {
          font-size: @fz26;
          color: #3f3f3f;
          line-height: 0.4rem;
          .ellipsis2;
        }
        .buy-price {
          position: absolute;
          left: 0;
          bottom: 0.4rem;
          font-size: @fz22;
          color: #ff4141;
        }
        .market-price {
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: @fz22;
          color: #9b9b9b;
          text-decoration: line-through;
        }
        .btn {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 1.68rem;
          height: 0.74rem;
          .over {
            line-height: 0.74rem;
            text-align: center;
            font-size: @fz24;
            color: #646464;
            background: #ededed;
            height: 0.74rem;
            border-radius: 0.08rem;
          }
          .go {
            height: 0.74rem;
            border-radius: 0.08rem;
            background: linear-gradient(180deg, #ff5600, #ff3000);
            p {
              padding-top: 0.1rem;
              font-size: @fz24;
              color: #fff;
              text-align: center;
            }
            .process-bg {
              margin: 0 0.1rem;
              height: 0.3rem;
              .flex-between;
              .process {
                width: 1rem;
                height: 0.06rem;
                background: #ffaa91;
                border-radius: 0.03rem;
                overflow: hidden;
                i {
                  display: block;
                  background: #fff;
                  height: 0.06rem;
                }
              }
              span {
                color: #ffaa91;
                font-size: 0.2rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
